<template>
  <p
    class="assist-product-title"
    :class="`${colorClass} ${largeTitle ? 'large' : ''} ${componentClass}`"
  >
    <span>{{ coloredText }}</span>
    <span>{{ normalText }}</span>
  </p>
</template>

<script>
  export default {
    name: 'AssistProductTitle',
    props: {
      coloredText: {
        required: true,
        default: '',
        type: String,
      },
      normalText: {
        required: true,
        default: '',
        type: String,
      },
      largeTitle: {
        required: false,
        default: false,
        type: Boolean,
      },
      componentClass: {
        required: false,
        default: '',
        type: String,
      },
    },
    computed: {
      colorClass() {
        switch (this.coloredText) {
          case 'Estate':
            return 'estate-assist-color';
          case 'Edu':
            return 'education-assist-color';
          case 'Debt':
            return 'debt-assist-color';
          case 'Cash':
            return 'cash-assist-color';
          case 'Cost':
            return 'cost-assist-color';
          case 'Tax':
            return 'tax-assist-color';
          default:
            return '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .assist-product-title {
    margin: 0;
    font-size: 22px;
    font-size: 22px;
    font-weight: 700;
    line-height: 33px;
    text-wrap: nowrap;
    span:first-of-type {
      text-decoration: underline;
    }

    span:last-of-type {
      font-size: 22px;
      font-weight: 500;
      line-height: 33px;
      text-wrap: nowrap;
      color: #000000;
    }
  }

  .assist-product-title.large {
    font-size: 30px;
    font-weight: 700;
    line-height: 45px;
    text-wrap: nowrap;
    span:first-of-type {
      font-size: 30px;
      font-weight: 700;
      line-height: 45px;
      text-wrap: nowrap;
      color: #000000;
    }
    span:last-of-type {
      font-size: 30px;
      font-weight: 500;
      line-height: 45px;
      text-wrap: nowrap;
      color: #000000;
    }
  }

  .assist-product-title.estate-assist-color {
    span:first-of-type {
      color: #ed0080;
    }
  }

  .assist-product-title.education-assist-color {
    span:first-of-type {
      color: #7395ef;
    }
  }

  .assist-product-title.debt-assist-color {
    span:first-of-type {
      color: #d65e23;
    }
  }

  .assist-product-title.cash-assist-color {
    span:first-of-type {
      color: #8aba3e;
    }
  }

  .assist-product-title.cost-assist-color {
    span:first-of-type {
      color: #e9ab21;
    }
  }

  .assist-product-title.tax-assist-color {
    span:first-of-type {
      color: #e9ab21;
    }
  }
</style>
